
<form #mapForm="ngForm" autocomplete="off">

  <certificate [type]="'server'"
               (onGenerateCertificateSubmit)="onGenerateCertificateSubmit($event)"
               (onLoadCertificateSubmit)="onLoadCertificateSubmit($event)"
               (onViewCurrentCertificate)="onViewCurrentCertificate()"
  ></certificate>



</form>















